import Vue from "vue";
import { Message } from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
Vue.prototype.$message = Message;

import { compressImage } from "../components/compressImage";

var Utils = {
  localResizeImg(uploadedFile, form, paramsName) {
    const file = uploadedFile && uploadedFile.target && uploadedFile.target.files
      ? uploadedFile.target.files[0]
      : null;
    if (!file) {
      Vue.prototype.$message.error("上传图片文件为空！");
      return Promise.reject(new Error("上传图片文件为空！"));
    }

    return compressImage(file, { quality: 0.2 }).then(base64 => {
      form[paramsName] = base64;
      return base64;
    }).catch(err => {
      const message = typeof err === "string"
        ? err
        : (err && err.message) || "图片压缩失败";
      Vue.prototype.$message({
        type: "error",
        message,
      });
      throw err;
    });
  },
  isDaylightSavingTime() {
    // 夏令时开始于3月的第2个星期日，结束于11月的第1个星期日
    const date = new Date(); // 获取当前日期和时间

    return this.checkBeijingTime(date.format("yyyy-MM-dd hh:mm:ss"));
  },

  /**
   * 判断给定时间是否处于美国的夏令时
   * @param {Date} date - 需要判断的时间
   * @param {string} timezone - 时区（例如："America/New_York"）
   * @returns {boolean} - 如果是夏令时返回 true，否则返回 false
   */
  isDST(date, timezone = "America/Los_Angeles") {
    // 将时间转换为目标时区的字符串
    const dateString = date.toLocaleString("en-US", { timeZone: timezone, hour12: false });

    // 将字符串重新解析为 Date 对象
    const localDate = new Date(dateString);

    // 获取目标时区的 UTC 偏移量（分钟）
    const offset = localDate.getTimezoneOffset();

    // 判断是否是夏令时（夏令时偏移量通常比标准时间少 60 分钟）
    return offset < new Date(localDate.getFullYear(), 0, 1).getTimezoneOffset();
  },

  /**
   * 判断美国洛杉矶当前是否处于夏令时（基于北京时间）
   * @param {Date} [date] - 可选的北京时间Date对象（自动转UTC处理）
   * @returns {boolean} 是否处于夏令时
   */
  isLosAngelesDST(date = new Date()) {
    // 获取UTC时间的年份
    const year = date.getUTCFullYear();

    // 计算夏令时开始和结束的UTC时间
    const dstStart = this.getMarchSecondSundayUTC(year);
    const dstEnd = this.getNovemberFirstSundayUTC(year);

    // 判断当前时间是否在区间内
    return date >= dstStart && date < dstEnd;
  },

  // 计算3月第二个星期日的10:00 UTC（对应美国夏令时开始）
  getMarchSecondSundayUTC(year) {
    const date = new Date(Date.UTC(year, 2, 1)); // March 1st UTC
    const firstSunday = 1 + ((7 - date.getUTCDay()) % 7);
    const secondSunday = firstSunday + 7;
    return new Date(Date.UTC(year, 2, secondSunday, 10));
  },

  // 计算11月第一个星期日的9:00 UTC（对应夏令时结束）
  getNovemberFirstSundayUTC(year) {
    const date = new Date(Date.UTC(year, 10, 1)); // November 1st UTC
    const firstSunday = 1 + ((7 - date.getUTCDay()) % 7);
    return new Date(Date.UTC(year, 10, firstSunday, 9));
  },

  // 方法2：通过北京时间字符串检测
  checkBeijingTime(beijingTimeStr) {
    // 将北京时间转UTC时间对象
    const [datePart, timePart] = beijingTimeStr.split(" ");
    const [y, m, d] = datePart.split("-").map(Number);
    const [H, M, S] = (timePart || "00:00:00").split(":").map(Number);
    const utcDate = new Date(Date.UTC(y, m - 1, d, H - 8, M, S));

    return this.isLosAngelesDST(utcDate);
  },

  /**
   * 获取默认业务日期：北京时间对应美国站点日期（与 businessMgmt 筛选项一致）
   * 北京时间 15/16 点前视为美国仍为前一日
   */
  getDefaultAmericaBusinessDate(asDate = false) {
    let hours = new Date().getHours();
    let offset = 0;
    let usaFirstHour = 16;
    this.isDaylightSavingTime() && (usaFirstHour = 15);
    hours < usaFirstHour && (offset = 1);
    let date = new Date();
    if (hours < usaFirstHour) {
      date = new Date(new Date().getTime() - offset * 24 * 60 * 60 * 1000);
    }
    return asDate ? date : date.format("yyyy-MM-dd");
  },

  // 测试用例
};

export default Utils;
